import React, { useState } from 'react';
import Select from 'react-select';
import './enquiry.css'
import data from './enquiry.json'
import Footer from '../../Footer';
import { color } from 'framer-motion';
import { Helmet } from 'react-helmet';

function Enquiry() {

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [number, setNumber] = useState('');

  const [selectedCollege, setSelectedCollege] = useState(null);
  const [collegeList, setCollegeList] = useState(data?.collegeList)

  const [selectedYear, setSelectedYear] = useState(null);
  const [degreeList, setDegreeList] = useState(data?.degreeList)

  const [selectedBranch, setSelectedBranch] = useState(null);
  const [branchList, setBranchList] = useState(data?.branchList);

  const [selectedOption, setSelectedOption] = useState([]);
  const [batchesList, setOptions] = useState(data?.batchesList)

  const [coursesList, setCoursesList] = useState(data?.coursesList)
  const [intrestedCourse, setIntrestedCourse] = useState([]);


  /**
 * @function handleChange
 * @author Vishal Lohbande
 *
 * Description:
 * - Updates the state variable `selectedOption` with the new selected value.
 * - Designed to be used as an event handler for selection components (e.g., dropdowns).
 *
 * Usage:
 * - Pass this function as an `onChange` handler to selection input components.
 *
 * Example:
 * ```jsx
 * <Select onChange={handleChange} value={selectedOption} />
 * ```
 */
  const handleChange = (selected) => {
    setSelectedOption(selected);
  };


  /**
 * @function handleIntrestedCourse
 * @author Vishal Lohbande
 *
 * Description:
 * - Updates the state variable `intrestedCourse` with the selected value.
 * - Intended to be used as an event handler for selection inputs related to course interests.
 *
 * Usage:
 * - Pass this function as an `onChange` handler to a course selection component.
 *
 * Example:
 * ```jsx
 * <Select onChange={handleIntrestedCourse} value={intrestedCourse} />
 * ```
 *
 * Notes:
 * - Make sure `intrestedCourse` state is initialized using `useState`.
 */
  const handleIntrestedCourse = (selected) => {
    setIntrestedCourse(selected)
  }

  const [otherRequest, setOtherRequest] = useState('');
  const [message, setMessage] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [otherRequestMsg, setOtherRequestMsg] = useState(false);


  /*function to check the provided mobile no is valid or not*/
  /**
  * @function isValidMobile
  * @author Vishal Lohbande
  *
  * Description:
  * - Validates whether the input string is either a valid Indian mobile number or a valid email address.
  * - Uses two regular expressions:
  *   - `mobileRegex`: Matches a 10-digit Indian mobile number starting with digits 6-9.
  *   - `emailRegex`: Matches a general email address format.
  * - Returns `true` if the input matches either pattern, otherwise returns `false`.
  *
  * Usage:
  * - Used to validate user inputs that accept either a mobile number or an email address.
  *
  * Notes:
  * - The mobile number regex strictly matches Indian mobile numbers.
  * - The email regex covers common email patterns but may not capture all valid emails.
  *
  * Example:
  * ```js
  * isValidMobile('9876543210');  // true
  * isValidMobile('user@example.com');  // true
  * isValidMobile('12345');  // false
  * ```
  */
  const isValidMobile = (input) => {
    const mobileRegex = /^[6-9]\d{9}$/; // Indian mobile number pattern (10 digits, starts with 6-9)
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // General email pattern

    if (mobileRegex.test(input)) {
      return true;
    } else if (emailRegex.test(input)) {
      return true;
    } else {
      return false;
    }
  };

  /**
   * @constant isValidMail
   * @author Vishal Lohbande
   *
   * Description:
   * - A React state variable to track the validity of an email input.
   * - Initialized to `false`.
   *
   * Usage:
   * - Used to conditionally render UI or validate form input based on email correctness.
   */
  /**
   * @function isValidEmail
   * @author Vishal Lohbande
   *
   * Description:
   * - Validates whether a given string is a properly formatted email address.
   * - Uses a regular expression to test the email format.
   * - Returns `true` if the email matches the pattern; otherwise, returns `false`.
   *
   * Usage:
   * - Called to validate email input fields.
   *
   * Notes:
   * - The regex is a simple pattern matching most common emails but might not cover all valid cases.
   *
   * Example:
   * ```js
   * isValidEmail("user@example.com"); // true
   * isValidEmail("invalid-email");    // false
   * ```
   */

  const [isValidMail, setIsValidMail] = useState(false)
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }



  const [loader, setLoader] = useState(false); //to handle button loader
  const [error, setError] = useState(false); // to handle error
  const [inValidNumber, setInValidNumber] = useState(false); //to number validation
  const [popup, setPopup] = useState(false);


  var stdData = {
    date: '',
    name: '',
    number: '',
    email: '',
    courseIntrested: '',
    college: '',
    year: '',
    branch: '',
    batches: '',
    reference: ''
  }

  const formatDateTime = (dateTime) => {
    try {
      const date = new Date(dateTime);
      const options = { year: "numeric", month: "2-digit", day: "2-digit" };
      const formattedDateSplit = date.toLocaleDateString("en-GB", options).replace(/\//g, "-").split('-');
      const formattedDate = `${formattedDateSplit[2]}-${formattedDateSplit[1]}-${formattedDateSplit[0]}`
      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const period = hours >= 12 ? "PM" : "AM";
      const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${"00"}`;
      return `${formattedDate} ${formattedTime}`;
    } catch (err) {

    }

  };
  /**
 * @function handleSubmit
 * @author Vishal Lohbande
 *
 * Description:
 * - Handles form submission asynchronously.
 * - Prevents default form submission behavior (commented out, but can be enabled).
 * - Collects and prepares form data from state variables.
 * - Validates required fields to ensure none are empty or null.
 * - Validates the mobile number format using `isValidMobile`.
 * - Sends form data as `FormData` via a POST request to a Google Apps Script endpoint.
 * - On success:
 *    - Resets form states and clears inputs.
 *    - Shows a popup notification for 3 seconds.
 * - On failure:
 *    - Logs error, shows alert, and resets submission states.
 *
 * Usage:
 * - Intended to be used as a submit handler for a controlled form component.
 *
 * Notes:
 * - Assumes multiple state setters like `setName`, `setEmail`, etc. are defined.
 * - Uses `setIsSuccess`, `setError`, `setInValidNumber`, and `setPopup` for UI feedback.
 * - Make sure to uncomment `e.preventDefault()` to prevent page reload on submit.
 **/
  const handleSubmit = async (e) => {
    // e.preventDefault();
    setIsSuccess(true)


    stdData = {
      date: formatDateTime(new Date().toISOString()),
      name: name,
      number: number,
      email: email,
      reason: message,
      courseIntrested: intrestedCourse.map(item => item.label).join(', '),
      college: selectedCollege?.label || '',
      year: selectedYear?.label || '',
      branch: selectedBranch?.label || '',
      batches: selectedOption.map(item => item.label).join(', '),
      reference: message,
      message: "",
      type: "enquiry-form"
    }

    setInValidNumber(false);
    if (stdData.name) setIsSuccess(true);


    /**
 * @constant isInvalid
 * @author Vishal Lohbande
 *
 * Description:
 * - Checks if any required field in the `stdData` object is either `null` or an empty string (`''`).
 * - Uses `Array.some()` to iterate through the specified fields and detect invalid entries.
 * - Returns `true` if at least one field is invalid; otherwise, returns `false`.
 *
 * Usage:
 * - Used for form validation to ensure all required fields have valid, non-empty values before submission.
 *
 * Fields checked:
 * - `name`, `number`, `email`, `reason`, `course`, `college`, `branch`, `year`, `courseIntrested`, `reference`
 *
 * Example:
 * ```js
 * if (isInvalid) {
 *   // Show error or prevent form submission
 * }
 * ```
 */
    const isInvalid = [
      stdData.name,
      stdData.number,
      stdData.email,
      stdData.reason,
      stdData.course,
      stdData.college,
      stdData.branch,
      stdData.year,
      stdData.courseIntrested,
      stdData.reference
    ].some(field => field === null || field === '');


    if (isInvalid) {
      setError(true);
      setIsSuccess(false);
      return;
    }

    if (!isValidMobile(stdData.number)) {
      setIsSuccess(false);
      setInValidNumber(true);
      return;
    }


    /**
 * @constant formData
 * @author Vishal Lohbande
 *
 * Description:
 * - Creates a new `FormData` object for submitting form data via HTTP request.
 * - Appends the current date with key `'date'`.
 * - Iterates over all keys in the `stdData` object and appends each key-value pair to `formData`.
 *
 * Usage:
 * - Used to package form fields in a format suitable for multipart/form-data POST requests.
 *
 * Notes:
 * - The date appended is a JavaScript `Date` object (not a formatted string).
 * - Ensure backend can handle date format sent in this way or convert to string if needed.
 *
 * Example:
 * ```js
 * fetch(url, {
 *   method: 'POST',
 *   body: formData
 * });
 * ```
 */
    const formData = new FormData();
    formData.append('date', formatDateTime(new Date()));
    Object.keys(stdData).forEach(key => {
      formData.append(key, stdData[key]);
    });

    try {

      const response = await fetch('https://script.google.com/macros/s/AKfycbzOh_Tj3DBaagd2iYN1CQ0mREBM8n3fLEtjvYfAFXr2yji5FpLBm9AL4A7b1BKYbygt_Q/exec', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) throw new Error('Network error or script issue');

      // Reset on success
      setIsSuccess(false);
      setError(false)
      stdData = {
        date: '',
        name: '',
        number: '',
        email: '',
        courseIntrested: '',
        college: '',
        year: '',
        branch: '',
        batches: '',
        reference: ''
      };

      setName('');
      setEmail('');
      setNumber('')
      setSelectedCollege(null);
      setSelectedYear(null)
      setSelectedBranch(null);
      setSelectedOption([]);
      setIntrestedCourse([]);
      setMessage('')
      setPopup(true);

      const timer = setTimeout(() => {
        setPopup(false);
      }, 3000);

      return () => clearTimeout(timer);
    } catch (error) {
      console.error(error);
      alert("Not Submitted, Please Try Again");
      setIsSuccess(false);
      setLoader(false);
    }
  };

  const handleMessage = (e) => setMessage(e.target.value);
  const handleName = (e) => setName(e.target.value);
  const handleNumber = (e) => setNumber(e.target.value)
  const handleEmail = (e) => {
    setEmail(e.target.value)
    if (!isValidEmail(e.target.value)) {
      setIsSuccess(false);
      setIsValidMail(true);
      return;
    } else {
      setError(false)
      setIsValidMail(false);
    }
  };


  return (
    <div className="C2wContactUs_ctn">
      <Helmet>
        {/* 
                    Purpose: Defines the page title displayed in search results and browser tabs. 
                             It’s one of the most important SEO elements. 
                    */}
        <title>{`Contact us for best learning programming languages`}</title>

        {/* 
                    Purpose: Provides a brief summary of the page content in search results. 
                             While not a direct ranking factor, it influences CTR. 
                    */}
        <meta name="description" content="" />

        {/* Purpose: Controls indexing and link-following behavior. */}
        <meta name="robots" content="index, follow" />

      </Helmet>
      <div className='C2wContactUs_ctn_scroller'>
        <div className="C2w_Contact_dataholder">
          <div className="C2wContact_dataholder_form">
            <div className="C2wContact_dataholder_form_title font-poppins">Contact Us</div>
            <form onSubmit={(e) => e.preventDefault()}>
              <input className='contact_input'
                value={name}
                maxLength="25"
                minLength="3"
                onChange={handleName}
                id="personalDetails-name"
                type="text"
                placeholder="Name"
                required
                style={{
                  borderColor: error && name?.trim() === '' ? 'red' : '#ffffff',
                  width: window.innerWidth > 768 ? "80%" : "98%"
                }}
              />
              <input
                className='contact_input'
                value={email}
                maxLength="70"
                minLength="3"
                onChange={handleEmail}
                type="email"
                id="personalDetails-email"
                placeholder="Email id"
                required
                style={{
                  borderColor: (error && email === '') || isValidMail ? 'red' : '#ffffff',
                  width: window.innerWidth > 768 ? "80%" : "98%"
                }}
              />
              <input
                className='contact_input'
                value={number}
                maxLength="10"
                onKeyPress={(event) =>
                  event.key >= 0 && event.key <= 9 ? true : event.preventDefault()
                }
                minLength="10"
                onChange={handleNumber}
                type="tel"
                id="personalDetails-phone"
                placeholder="Phone Number"
                required
                style={{
                  borderColor: error && number === '' ? 'red' : '#ffffff',
                  width: window.innerWidth > 768 ? "80%" : "98%"
                }}
              />
              <div className='selet_holder' style={{
                width: window.innerWidth > 768 ? "80%" : "98%",
                borderColor: error && (selectedCollege === '' || selectedCollege === null) ? 'red' : '#ffffff',
              }}>
                <Select
                  options={collegeList}
                  placeholder="Search college"
                  value={selectedCollege ? selectedCollege : null}
                  onChange={(selected) => {
                    setSelectedCollege(selected);
                  }}
                  styles={{
                    singleValue: (base) => ({
                      ...base,
                      color: "white",
                    }),
                  }}
                />
              </div>
              <div className='selet_holder' style={{
                width: window.innerWidth > 768 ? "80%" : "98%",
                borderColor: error && (selectedYear === '' || selectedYear === null) ? 'red' : '#ffffff',

              }}>
                <Select
                  options={degreeList}
                  clearOnBlur={true}
                  placeholder="Select degree"
                  onChange={(selected) => {
                    setSelectedYear(selected);
                  }}
                  value={selectedYear ? selectedYear : null}
                />
              </div>
              <div className='selet_holder' style={{
                width: window.innerWidth > 768 ? "80%" : "98%",
                borderColor: error && (selectedBranch === '' || selectedBranch === null) ? 'red' : '#ffffff',
              }}>
                <Select
                  options={branchList}
                  placeholder="Select branch"
                  onChange={(selected) => {
                    setSelectedBranch(selected);
                  }}
                  value={selectedBranch ? selectedBranch : null}
                />
              </div>
              <div className='selet_holder' style={{
                width: window.innerWidth > 768 ? "80%" : "98%",
                borderColor: error && (selectedOption.length === 0 || selectedOption === null) ? 'red' : '#ffffff'
              }}>
                <Select
                  isMulti
                  value={selectedOption}
                  onChange={handleChange}
                  options={batchesList}
                  placeholder={'Select attended batches'}
                />

              </div>
              <div className='selet_holder' style={{
                width: window.innerWidth > 768 ? "80%" : "98%",
                borderColor: error && (intrestedCourse.length === 0 || intrestedCourse === null) ? 'red' : '#ffffff',
              }}>
                <Select
                  isMulti
                  options={coursesList}
                  searchable={false}
                  placeholder="Interested for (course)"
                  onChange={handleIntrestedCourse}
                  disabled={false} // Add your condition for disabling
                  value={intrestedCourse}

                />
              </div>
              {intrestedCourse && intrestedCourse.label === "other" && (
                <input
                  className='contact_input'
                  value={otherRequest}
                  maxLength="25"
                  minLength="3"
                  onChange={(e) => {
                    setOtherRequest(e.target.value);
                    setOtherRequestMsg(null);
                  }}
                  id="personalDetails-otherRequest"
                  type="text"
                  placeholder="Other Requested Course"
                  required
                  style={{
                    borderColor: otherRequestMsg ? 'red' : '#ffffff',
                    width: window.innerWidth > 768 ? "80%" : "98%"
                  }}
                />
              )}
              <input
                className='contact_input'
                value={message}
                onChange={handleMessage}
                type="text"
                id="personalDetails-message"
                placeholder="Reference"
                required
                style={{
                  borderColor: error && message.trim() === '' ? 'red' : '#ffffff',
                  width: window.innerWidth > 768 ? "80%" : "98%"
                }}
              />
              <button className='C2wLoginPermission_table_submitbtn' onClick={!isSuccess ? handleSubmit : null}>{isSuccess ? <div className='btnLoader'></div> : "Submit"}</button>
            </form>
            {
              popup ? <div className='C2wrequest_popup'>
                <div className='C2wrequest_popup_container'>
                  <svg width="100" height="94" viewBox="0 0 100 94" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="49.0815" cy="46.0102" r="32.0883" fill="#00B64C" />
                    <path d="M60.983 36.3818C60.8251 36.2039 60.6372 36.0627 60.4301 35.9663C60.223 35.8699 60.001 35.8203 59.7766 35.8203C59.5523 35.8203 59.3302 35.8699 59.1232 35.9663C58.9161 36.0627 58.7282 36.2039 58.5702 36.3818L45.9115 50.5421L40.5932 44.5818C40.4292 44.4049 40.2356 44.2657 40.0234 44.1723C39.8113 44.0789 39.5848 44.0331 39.3568 44.0375C39.1288 44.0419 38.9038 44.0964 38.6947 44.198C38.4855 44.2995 38.2963 44.4461 38.1379 44.6293C37.9795 44.8125 37.8549 45.0288 37.7713 45.2658C37.6877 45.5028 37.6467 45.7558 37.6507 46.0105C37.6546 46.2652 37.7034 46.5166 37.7943 46.7502C37.8852 46.9838 38.0164 47.1952 38.1804 47.3721L44.7051 54.6611C44.8631 54.839 45.051 54.9802 45.2581 55.0766C45.4651 55.1729 45.6872 55.2225 45.9115 55.2225C46.1359 55.2225 46.3579 55.1729 46.565 55.0766C46.7721 54.9802 46.96 54.839 47.1179 54.6611L60.983 39.1721C61.1555 38.9943 61.2932 38.7786 61.3873 38.5385C61.4815 38.2984 61.5301 38.0391 61.5301 37.7769C61.5301 37.5148 61.4815 37.2555 61.3873 37.0154C61.2932 36.7753 61.1555 36.5595 60.983 36.3818Z" fill="white" />
                    <circle cx="13.778" cy="7.87368" r="7.87368" fill="#00B64C" fill-opacity="0.2" />
                    <circle cx="93.1719" cy="15.749" r="5.90526" fill="#00B64C" fill-opacity="0.2" />
                    <ellipse cx="3.93684" cy="69.8744" rx="3.93684" ry="3.60877" fill="#00B64C" fill-opacity="0.2" />
                    <circle cx="34.777" cy="91.2028" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                    <circle cx="85.2985" cy="83.3356" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                    <circle cx="89.235" cy="58.3903" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                    <circle cx="56.4274" cy="3.93717" r="1.96842" fill="#00B64C" fill-opacity="0.2" />
                  </svg>
                  <h1>Registered Successfully</h1>
                </div>
              </div> : null
            }
          </div>
        </div>
      </div>
      <div className="ADfooter__container">
        <Footer />
      </div>
    </div>
  );
}

export default Enquiry;
